import React from 'react';
import { Layout } from '../../components/Layout';
import { Card } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Container } from '../../components/ui/Container';
import { Section } from '../../components/ui/Section';
import { Shield, AlertTriangle, CheckCircle, XCircle, Info } from 'lucide-react';
import { Link } from 'react-router-dom';
export function Scope() {
  return <Layout data-id="element-1109">
      <Section spacing="lg" data-id="element-1110">
        <Container size="lg" data-id="element-1111">
          {/* Hero */}
          <div className="mb-12 text-center animate-fade-in-up" data-id="element-1112">
            <Badge variant="primary" size="lg" className="mb-6" data-id="element-1113">
              Platform Scope
            </Badge>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-100 mb-6" data-id="element-1114">
              Scope & Non-Guarantee Statement
            </h1>
            <p className="text-lg md:text-xl text-slate-400 max-w-3xl mx-auto" data-id="element-1115">
              Understanding what this platform does, what it doesn't claim, and
              the context of its educational and defensive purpose.
            </p>
          </div>

          <div className="grid lg:grid-cols-3 gap-8" data-id="element-1116">
            {/* Main Content */}
            <div className="lg:col-span-2 space-y-12" data-id="element-1117">
              {/* What This Platform Does */}
              <section className="animate-fade-in-up animation-delay-100" data-id="element-1118">
                <h2 className="text-2xl font-bold text-slate-100 mb-6 font-mono flex items-center" data-id="element-1119">
                  <CheckCircle className="h-6 w-6 mr-3 text-emerald-400" data-id="element-1120" />
                  What This Platform Does
                </h2>
                <Card glass padding="lg" data-id="element-1121">
                  <ul className="space-y-4 text-slate-300" data-id="element-1122">
                    <li className="flex items-start" data-id="element-1123">
                      <span className="text-emerald-400 mr-3 mt-1 flex-shrink-0" data-id="element-1124">
                        ✓
                      </span>
                      <div data-id="element-1125">
                        <strong className="text-slate-100" data-id="element-1126">
                          Provides Educational Guidance:
                        </strong>
                        <p className="text-sm text-slate-400 mt-1" data-id="element-1127">
                          Offers standards-aligned cybersecurity protocols, best
                          practices, and defensive strategies for individuals
                          and organizations.
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1128">
                      <span className="text-emerald-400 mr-3 mt-1 flex-shrink-0" data-id="element-1129">
                        ✓
                      </span>
                      <div data-id="element-1130">
                        <strong className="text-slate-100" data-id="element-1131">
                          Aligns with Global Standards:
                        </strong>
                        <p className="text-sm text-slate-400 mt-1" data-id="element-1132">
                          References NIST CSF 2.0, ISO/IEC 27001, CIS Controls
                          v8, and other internationally recognized frameworks.
                          Additional standards (sectoral, risk, privacy,
                          cloud-specific) are referenced where contextually
                          relevant.
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1133">
                      <span className="text-emerald-400 mr-3 mt-1 flex-shrink-0" data-id="element-1134">
                        ✓
                      </span>
                      <div data-id="element-1135">
                        <strong className="text-slate-100" data-id="element-1136">
                          Supports Readiness & Policy:
                        </strong>
                        <p className="text-sm text-slate-400 mt-1" data-id="element-1137">
                          Helps users assess their security posture, identify
                          gaps, and develop actionable improvement plans.
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1138">
                      <span className="text-emerald-400 mr-3 mt-1 flex-shrink-0" data-id="element-1139">
                        ✓
                      </span>
                      <div data-id="element-1140">
                        <strong className="text-slate-100" data-id="element-1141">
                          Provides Contextual Tools:
                        </strong>
                        <p className="text-sm text-slate-400 mt-1" data-id="element-1142">
                          Offers risk assessments, compliance guides, and
                          security tools tailored to individuals and
                          organizations.
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1143">
                      <span className="text-emerald-400 mr-3 mt-1 flex-shrink-0" data-id="element-1144">
                        ✓
                      </span>
                      <div data-id="element-1145">
                        <strong className="text-slate-100" data-id="element-1146">
                          Maintains Ethical Standards:
                        </strong>
                        <p className="text-sm text-slate-400 mt-1" data-id="element-1147">
                          Focuses exclusively on defensive cybersecurity. No
                          offensive techniques, exploit development, or
                          unauthorized access methods are provided.
                        </p>
                      </div>
                    </li>
                  </ul>
                </Card>
              </section>

              {/* What This Platform Does NOT Claim */}
              <section className="animate-fade-in-up animation-delay-200" data-id="element-1148">
                <h2 className="text-2xl font-bold text-slate-100 mb-6 font-mono flex items-center" data-id="element-1149">
                  <XCircle className="h-6 w-6 mr-3 text-red-400" data-id="element-1150" />
                  What This Platform Does NOT Claim
                </h2>
                <Card glass padding="lg" className="border-red-500/20" data-id="element-1151">
                  <ul className="space-y-4 text-slate-300" data-id="element-1152">
                    <li className="flex items-start" data-id="element-1153">
                      <span className="text-red-400 mr-3 mt-1 flex-shrink-0" data-id="element-1154">
                        ✕
                      </span>
                      <div data-id="element-1155">
                        <strong className="text-slate-100" data-id="element-1156">
                          No Guarantee of Immunity:
                        </strong>
                        <p className="text-sm text-slate-400 mt-1" data-id="element-1157">
                          Following these protocols does not guarantee complete
                          protection against cyber threats. Security is a
                          continuous process, not a one-time achievement.
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1158">
                      <span className="text-red-400 mr-3 mt-1 flex-shrink-0" data-id="element-1159">
                        ✕
                      </span>
                      <div data-id="element-1160">
                        <strong className="text-slate-100" data-id="element-1161">
                          Not a Substitute for Professional Services:
                        </strong>
                        <p className="text-sm text-slate-400 mt-1" data-id="element-1162">
                          This platform does not replace professional security
                          consulting, audits, incident response, or legal
                          advice. Consult qualified professionals for specific
                          needs.
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1163">
                      <span className="text-red-400 mr-3 mt-1 flex-shrink-0" data-id="element-1164">
                        ✕
                      </span>
                      <div data-id="element-1165">
                        <strong className="text-slate-100" data-id="element-1166">
                          Not Certification or Compliance Validation:
                        </strong>
                        <p className="text-sm text-slate-400 mt-1" data-id="element-1167">
                          Using this platform does not certify compliance with
                          any standard or regulation. Formal audits and
                          certifications require accredited third-party
                          assessors.
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1168">
                      <span className="text-red-400 mr-3 mt-1 flex-shrink-0" data-id="element-1169">
                        ✕
                      </span>
                      <div data-id="element-1170">
                        <strong className="text-slate-100" data-id="element-1171">
                          No Active Monitoring or Protection:
                        </strong>
                        <p className="text-sm text-slate-400 mt-1" data-id="element-1172">
                          This is an educational resource, not a security
                          service. We do not monitor your systems, detect
                          threats, or respond to incidents.
                        </p>
                      </div>
                    </li>
                    <li className="flex items-start" data-id="element-1173">
                      <span className="text-red-400 mr-3 mt-1 flex-shrink-0" data-id="element-1174">
                        ✕
                      </span>
                      <div data-id="element-1175">
                        <strong className="text-slate-100" data-id="element-1176">
                          No Liability for Outcomes:
                        </strong>
                        <p className="text-sm text-slate-400 mt-1" data-id="element-1177">
                          We are not liable for security incidents, data
                          breaches, or any damages resulting from the use or
                          misuse of this platform. See our{' '}
                          <Link to="/about/disclaimer" className="text-cyan-400 hover:text-cyan-300 underline" data-id="element-1178">
                            Legal Disclaimer
                          </Link>{' '}
                          for full terms.
                        </p>
                      </div>
                    </li>
                  </ul>
                </Card>
              </section>

              {/* Context & Purpose */}
              <section className="animate-fade-in-up animation-delay-300" data-id="element-1179">
                <h2 className="text-2xl font-bold text-slate-100 mb-6 font-mono flex items-center" data-id="element-1180">
                  <Info className="h-6 w-6 mr-3 text-cyan-400" data-id="element-1181" />
                  Educational & Defensive Context
                </h2>
                <Card glass padding="lg" data-id="element-1182">
                  <div className="space-y-4 text-slate-300" data-id="element-1183">
                    <p data-id="element-1184">
                      <strong className="text-slate-100" data-id="element-1185">
                        CyberSecurityProtocol
                      </strong>{' '}
                      is designed as a{' '}
                      <strong className="text-cyan-400" data-id="element-1186">
                        public baseline edition
                      </strong>{' '}
                      for education, readiness assessment, and policy reference.
                    </p>
                    <p className="text-sm text-slate-400" data-id="element-1187">
                      Our mission is to democratize access to professional-grade
                      cybersecurity knowledge, helping individuals and
                      organizations build stronger defensive capabilities.
                    </p>
                    <p className="text-sm text-slate-400" data-id="element-1188">
                      We focus exclusively on{' '}
                      <strong className="text-emerald-400" data-id="element-1189">
                        defensive cybersecurity
                      </strong>
                      :
                    </p>
                    <ul className="space-y-2 text-sm text-slate-400 ml-6" data-id="element-1190">
                      <li className="flex items-start" data-id="element-1191">
                        <span className="text-cyan-400 mr-2" data-id="element-1192">▸</span>
                        <span data-id="element-1193">Risk assessment and mitigation</span>
                      </li>
                      <li className="flex items-start" data-id="element-1194">
                        <span className="text-cyan-400 mr-2" data-id="element-1195">▸</span>
                        <span data-id="element-1196">Security controls and best practices</span>
                      </li>
                      <li className="flex items-start" data-id="element-1197">
                        <span className="text-cyan-400 mr-2" data-id="element-1198">▸</span>
                        <span data-id="element-1199">Incident preparedness and response</span>
                      </li>
                      <li className="flex items-start" data-id="element-1200">
                        <span className="text-cyan-400 mr-2" data-id="element-1201">▸</span>
                        <span data-id="element-1202">Compliance and governance frameworks</span>
                      </li>
                      <li className="flex items-start" data-id="element-1203">
                        <span className="text-cyan-400 mr-2" data-id="element-1204">▸</span>
                        <span data-id="element-1205">Threat awareness and resilience building</span>
                      </li>
                    </ul>
                    <p className="text-sm text-slate-400" data-id="element-1206">
                      We do <strong className="text-red-400" data-id="element-1207">NOT</strong>{' '}
                      provide offensive techniques, exploit development,
                      unauthorized access methods, or any content that could be
                      used for malicious purposes.
                    </p>
                  </div>
                </Card>
              </section>

              {/* Responsible Use */}
              <section className="animate-fade-in-up animation-delay-400" data-id="element-1208">
                <h2 className="text-2xl font-bold text-slate-100 mb-6 font-mono flex items-center" data-id="element-1209">
                  <Shield className="h-6 w-6 mr-3 text-amber-400" data-id="element-1210" />
                  Responsible Use Guidelines
                </h2>
                <Card glass padding="lg" className="border-amber-500/20" data-id="element-1211">
                  <div className="space-y-4 text-slate-300" data-id="element-1212">
                    <p className="text-sm text-slate-400" data-id="element-1213">
                      Users of this platform are expected to:
                    </p>
                    <ul className="space-y-3 text-sm text-slate-400" data-id="element-1214">
                      <li className="flex items-start" data-id="element-1215">
                        <span className="text-amber-400 mr-3 mt-0.5" data-id="element-1216">⚠</span>
                        <span data-id="element-1217">
                          Use the information for legitimate defensive purposes
                          only
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1218">
                        <span className="text-amber-400 mr-3 mt-0.5" data-id="element-1219">⚠</span>
                        <span data-id="element-1220">
                          Verify recommendations with qualified professionals
                          before implementation
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1221">
                        <span className="text-amber-400 mr-3 mt-0.5" data-id="element-1222">⚠</span>
                        <span data-id="element-1223">
                          Adapt guidance to their specific context, risk
                          profile, and regulatory requirements
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1224">
                        <span className="text-amber-400 mr-3 mt-0.5" data-id="element-1225">⚠</span>
                        <span data-id="element-1226">
                          Maintain continuous security awareness and improvement
                        </span>
                      </li>
                      <li className="flex items-start" data-id="element-1227">
                        <span className="text-amber-400 mr-3 mt-0.5" data-id="element-1228">⚠</span>
                        <span data-id="element-1229">
                          Report any security vulnerabilities responsibly (see{' '}
                          <Link to="/about/contact" className="text-cyan-400 hover:text-cyan-300 underline" data-id="element-1230">
                            Contact Us
                          </Link>
                          )
                        </span>
                      </li>
                    </ul>
                  </div>
                </Card>
              </section>

              {/* Version & Updates */}
              <section className="animate-fade-in-up animation-delay-500" data-id="element-1231">
                <Card glass padding="md" className="bg-slate-900/30" data-id="element-1232">
                  <div className="flex items-start space-x-3 text-sm text-slate-400" data-id="element-1233">
                    <Info className="h-5 w-5 text-cyan-400 flex-shrink-0 mt-0.5" data-id="element-1234" />
                    <div data-id="element-1235">
                      <p className="mb-2" data-id="element-1236">
                        <strong className="text-slate-200" data-id="element-1237">
                          Current Version:
                        </strong>{' '}
                        <span className="text-cyan-400 font-mono" data-id="element-1238">
                          v1.0.0 — Public Baseline Edition
                        </span>
                      </p>
                      <p data-id="element-1239">
                        This platform is continuously updated to reflect
                        evolving threats, standards, and best practices. See our{' '}
                        <Link to="/about/changelog" className="text-cyan-400 hover:text-cyan-300 underline" data-id="element-1240">
                          Changelog
                        </Link>{' '}
                        for version history and planned updates.
                      </p>
                    </div>
                  </div>
                </Card>
              </section>
            </div>

            {/* Sidebar */}
            <div className="space-y-6" data-id="element-1241">
              <Card glass padding="lg" className="sticky top-24 animate-fade-in-up animation-delay-600" data-id="element-1242">
                <h3 className="text-lg font-bold text-slate-100 mb-4 font-mono" data-id="element-1243">
                  Related Pages
                </h3>
                <div className="space-y-2" data-id="element-1244">
                  <Link to="/about/mission" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-1245">
                    Mission & Vision
                  </Link>
                  <Link to="/about/scope" className="block p-2 rounded bg-cyan-500/10 text-cyan-400 font-medium border border-cyan-500/20" data-id="element-1246">
                    Scope & Non-Guarantee
                  </Link>
                  <Link to="/about/standards" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-1247">
                    Standards Mapping
                  </Link>
                  <Link to="/about/changelog" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-1248">
                    Changelog
                  </Link>
                  <Link to="/about/governance" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-1249">
                    Governance
                  </Link>
                  <Link to="/about/disclaimer" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-1250">
                    Legal Disclaimer
                  </Link>
                  <Link to="/about/contact" className="block p-2 rounded hover:bg-slate-800/50 text-slate-400 hover:text-cyan-400 transition-colors" data-id="element-1251">
                    Contact Us
                  </Link>
                </div>
              </Card>
            </div>
          </div>
        </Container>
      </Section>
    </Layout>;
}